import { Divider, Flex } from "antd";
import { useCallback, useContext, useMemo } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";

import { FolderOpenOutlinedIcon, NoteInfoTypeIcon, PaperClipOutlinedIcon } from "@assets/icons";
import { CardItemStyled, CardTitle, KMdText700PrimaryBase, KMdTextSecondary65, KTag } from "@components";
import { KContext } from "@context";
import { ECardType, EDateTimeFormat, IItemCardProps, INote, IParams } from "@types";
import { CardItemContainer, MetadataDetail } from "..";
import { useCustomNavigate } from "@hooks";
import { formatDate, formatTimeRangeCard } from "@utils/date";

const NoteDescription = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  &.description {
    ol, ul {
      list-style-position: inside;
    }

    i, span {
      overflow-wrap: break-word;
    }
  }
`;

export const NoteItem = ({ card, isDetail, showMetadata, showTopics }: IItemCardProps<INote>) => {
  const {
    _id,
    title,
    description,
    startTime,
  } = card;
  const { cardId } = useParams<IParams>();
  const { navigate } = useCustomNavigate();
  const { setCardTypeSelected, navigateDetailCard } = useContext(KContext);

  const onClickItem = useCallback(() => {
    if (cardId === _id) return;
    if (!isDetail) {
      return navigate(
        _id,
        undefined,
        () => { setCardTypeSelected(ECardType.Notes); },
      );
    }
    navigateDetailCard(ECardType.Notes, _id);
  }, [_id, cardId]);

  return (
    <CardItemStyled $isActive={cardId === _id} onClick={onClickItem}>
      <CardItemContainer showMetadata={showMetadata} showTopics={showTopics} card={card}>
        <CardTitle icon={<NoteInfoTypeIcon width={20} height={20} />}>
          {title}
        </CardTitle>
        {startTime && (
          <KMdTextSecondary65>
            {formatDate(startTime, "FULL_MONTH_YEAR_WITH_TIME_AM_PM")}
          </KMdTextSecondary65>
        )}
        {description && (
          <NoteDescription
            className="description"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
      </CardItemContainer>
    </CardItemStyled>
  );
};
